@if (menuSettings) {
<div class="domain-container" [ngClass]="currentTheme">
  <mat-icon class="domain-button" [matMenuTriggerFor]="menu">apps</mat-icon>
  <mat-menu #menu="matMenu" class="avmup-menu">
    @for (app of cesarApplications; track app) {
    <a class="avmup-menu-item" href="{{ getUrl(app.url) }}" mat-menu-item>
      <img class="app-icon" src="{{ app.icon }}" />
      <span class="text">{{ app.display }}</span>
    </a>
    }
  </mat-menu>
</div>
}